module.exports = __webpack_public_path__ + "img/47_19.ec3e479e.png";